import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import NewDocument from "./pages/admin/NewDocument";
import DocumentDetail from "./pages/admin/DocumentDetail";
import Sign from "./pages/sign/Sign";
import SignComplete from "./pages/sign/SignComplete";

const PdfEditor = React.lazy(() => import("./pages/editor/PdfEditor"));

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-6 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route
          path="/edit"
          element={
            <React.Suspense
              fallback={<div className="p-6 text-slate-500">Opening editor…</div>}
            >
              <PdfEditor />
            </React.Suspense>
          }
        />
        <Route path="/admin/login" element={<Login />} />
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/new"
          element={
            <RequireAuth>
              <NewDocument />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/documents/:docId"
          element={
            <RequireAuth>
              <DocumentDetail />
            </RequireAuth>
          }
        />
        <Route path="/sign/:signerToken" element={<Sign />} />
        <Route path="/sign/:signerToken/done" element={<SignComplete />} />
        <Route path="*" element={<div className="p-6">Not found</div>} />
      </Routes>
    </AuthProvider>
  );
}
